import { useQuery } from 'react-query';
import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getOrderGroupById } from 'src/services/napi/ordersGroup/getOrderGroupById';
import { OrderGroupDetailed } from './interfaces/orderGroup.interface';

const fetchOrdersGroupById = async (groupId: string): Promise<OrderGroupDetailed | undefined> => {
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );

  if (!currentProject) return;
  const data: any | undefined = await getOrderGroupById(currentProject._id, groupId);

  if (!data) return;

  return data.data;
};

export const useGetOrderGroupById = (groupId: string) => {
  const { notify } = useNotification();

  return useQuery(
    [QueryKey.ORDER_GROUP_SELECTED, groupId],

    () => fetchOrdersGroupById(groupId),
    {
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
